
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Flex, Box } from '@chakra-ui/react';
import Sidebar from './Sidebar';
import Header from './Header';

export default function MainLayout() {

  return (
    <Flex h="100vh" bg="global.bg" overflowX="hidden">
      <Sidebar />
      <Flex flex={1} minW="0" direction="column" position="relative">
        <Header />
        <Box
          as="main"
          flex={1}
          minH={0}
          minW={0}
          p={6}
          display="flex"
          flexDirection="column"
        >
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
}
